import React, { memo, Suspense, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import createClasses from '../../styles';
import { Button, DialogTitle, CustomIcon } from '@p81-common/ui';
import Typography from '@mui/material/Typography';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import { env } from 'env';
import { Loading } from 'components/common/Elements/Elements';

import { useAuthDispatch } from 'contexts/auth-context';
import { logout } from 'contexts/actions/authActions';

// eslint-disable-next-line
export const HeaderMenus = memo(
  (props: {
    anchorEl: Element | null;
    handleSetAnchor: any;
    userItems: any;
    modalOpen: boolean;
    handleCloseModal: () => void;
    positionAnchor: any;
  }) => {
    const {
      anchorEl,
      handleSetAnchor,
      userItems,
      modalOpen,
      handleCloseModal,
      positionAnchor
    } = props;

    const { t } = useTranslation('settings');

    const dispatch = useAuthDispatch();

    const handleLogOut = () => {
      logout()(dispatch);
    };

    useEffect(() => {
      if (anchorEl) {
        document.querySelector('html')!.style.overflow = 'hidden';
        document.querySelector('body')!.style.paddingRight = '0px';
      } else {
        document.querySelector('html')!.style.removeProperty('overflow');
      }
    }, [anchorEl]);

    const classes = createClasses();

    return (
      <>
        <Menu
          keepMounted={false}
          anchorEl={anchorEl}
          open={anchorEl?.tagName === 'DIV'}
          onClose={handleSetAnchor(null)}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right'
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'right'
          }}
          classes={{
            paper: classes.userMenu
          }}
          disableAutoFocusItem
          PaperProps={{
            style: {
              transform: `translate(${positionAnchor.x - 158}px, ${
                positionAnchor.y + 33
              }px)`
            }
          }}
        >
          <Suspense fallback={<Loading className={classes.userMenu} />}>
            {userItems.map((item: any) => {
              const { label, handleClick, icon } = item;
              return (
                <MenuItem
                  key={label}
                  onClick={handleClick}
                  data-testid={`button-${label}`}
                >
                  <CustomIcon
                    src={icon}
                    className={classes.menuIcon}
                    color="black"
                  />
                  <Typography variant="body2">{label}</Typography>
                </MenuItem>
              );
            })}
          </Suspense>
        </Menu>
        <Dialog
          open={modalOpen}
          onClose={handleCloseModal}
          classes={{
            paper: classes.logoutDialogPaper
          }}
        >
          <DialogTitle
            icon={{
              src: `${env.REACT_APP_STATIC_ASSETS_URL}/icons/icon_logout.svg`
            }}
            onClose={handleCloseModal}
          >
            <Typography variant="h3">
              {t('settings:profile.LOG_OUT')}
            </Typography>
          </DialogTitle>
          <DialogContent>{t('settings:profile.YOU_WANT_EXIT')}</DialogContent>
          <DialogActions>
            <Button
              onClick={handleCloseModal}
              color="third"
              data-testid="button-dialogCancel"
            >
              {t('common:CANCEL')}
            </Button>
            <Button
              onClick={handleLogOut}
              color="primary"
              data-testid="button-dialogLogOut"
            >
              {t('settings:profile.LOG_OUT')}
            </Button>
          </DialogActions>
        </Dialog>
      </>
    );
  }
);
